import { Button, Form, FormInstance, Radio, Skeleton, Space } from 'antd';

import { OneOfFilterModel, RenderOptionsList } from './core';

const requiredRules = [
  { required: true, message: 'Поле обязательно для заполнения' },
];

type OneOfFilterFormProps = {
  form: FormInstance<{ value: OneOfFilterModel['value'] }>;
  options: RenderOptionsList;
  value?: OneOfFilterModel['value'];
  onSubmit: (value: OneOfFilterModel['value']) => void;
  onReset: () => void;
};
// eslint-disable-next-line mobx/missing-observer
export const OneOfFilterForm = ({
  form,
  options,
  value,
  onSubmit,
  onReset,
}: OneOfFilterFormProps) => {
  const handleSubmit = ({ value }: { value: OneOfFilterModel['value'] }) => {
    onSubmit(value);
  };

  const handleReset = () => {
    onReset();
  };

  const optionsList =
    options.length === 0 ? (
      <Skeleton style={{ minWidth: '100%' }} active />
    ) : (
      options.map(({ label, value }) => (
        <Radio value={value} key={value}>
          {label}
        </Radio>
      ))
    );

  return (
    <div className="ag-filter">
      <Form
        layout="vertical"
        className="ag-filter-wrapper ag-focus-managed"
        form={form}
        fields={[{ name: 'value', value }]}
        onFinish={handleSubmit}
        onReset={handleReset}
      >
        <div className="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
          <div
            className="ag-filter-body"
            role="presentation"
            aria-hidden="false"
          >
            <div
              role="presentation"
              data-asd="hi"
              className="ag-labeled ag-label-align-left ag-number-field ag-input-field ag-filter-from ag-filter-filter"
              aria-hidden="false"
            >
              <div
                style={{
                  width: '100%',
                  maxHeight: 500,
                  overflowY: 'auto',
                }}
              >
                <Form.Item name="value" rules={requiredRules} noStyle>
                  <Radio.Group style={{ width: '100%' }}>
                    <Space
                      direction="vertical"
                      style={{ width: '100%', padding: 4 }}
                    >
                      {optionsList}
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>
          </div>

          <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
            <Button type="primary" htmlType="submit" block>
              Найти
            </Button>
            <Button htmlType="reset" block>
              Сбросить
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};
